import { Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { FC, ReactNode } from 'react'
import { theme } from '../../../../theme'

interface Props {
    name: string
    value?: ReactNode
}
const ReferralProgramStatisticsItem: FC<Props> = ({ name, value = 0 }) => {
    return (
        <Grid
            sx={{
                border: '1px solid #E7E8EE',
                padding: '20px',
                borderRadius: '16px',
                width: '243px',
                [theme.breakpoints.down('md')]: {
                    width: '100%',
                },
            }}>
            <Typography marginBottom={1} variant="h4">
                {value}
            </Typography>
            <Typography variant="body2">{name}</Typography>
        </Grid>
    )
}

export default ReferralProgramStatisticsItem
